













import { defineComponent } from '@vue/composition-api';
import MeetingCard from '@/modules/ees/components/MeetingCard.vue';
import { UserStoreKey } from '@/store/StoreInjectionKeys';
import { injectStrict } from '@/lib/utils';

export default defineComponent({
  components:{
    MeetingCard,
  },
  setup(){
    const userStore = injectStrict(UserStoreKey);
    userStore.actions.getTodaysMeetings();

    return {
      userStore
    }
  }
})
